// extracted by mini-css-extract-plugin
export var buttonIcon = "X_fg";
export var badge = "X_fh";
export var hover = "X_fj";
export var selected = "X_d2";
export var rotate = "X_c";
export var dotty = "X_d";